(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-real"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nb-photo-carousel')) {
  customElements.define('nb-photo-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-direction]');
        const track = this.querySelector('.nb-photos__track');
        const card = this.querySelector('.nb-photos__card');
        if (!button || !track || !card) return;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        track.scrollBy({left: Number(button.dataset.direction) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, {signal: this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
